import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getReleaseInfo } from '@/service/proRequisition';
export default function userList(params, tabActive) {
  var finished = ref(false);
  // const list = ref<{ [propName: string]: string }[]>([])
  var detail = ref({});
  var getReleaseInfoAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getReleaseInfo(params.value);
          case 2:
            data = _context.sent;
            detail.value = data;
            finished.value = true;
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getReleaseInfoAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var list = computed(function () {
    console.log('list', tabActive.value);
    var arr = [];
    switch (tabActive.value) {
      case 0:
        arr = detail.value.slaves;
        break;
      case 1:
        arr = detail.value.done_slave;
        break;
      case 2:
        arr = detail.value.doing_slave;
        break;
    }
    return arr;
  });
  return [detail, list, finished, getReleaseInfoAsync];
}